<template>
    <div>
        <!-- 触发按钮 -->
        <div @click="modalVisible = true">
            <slot />
        </div>

        <!-- 业主方确认弹窗 -->
        <a-modal
                :visible="modalVisible"
                @cancel="cancel"
                :footer="null"
                :width="800"
                wrapClassName="owner-confirm-modal"
        >
            <!-- 标题区 -->
            <div class="modal-header">
                <span class="warning-icon">⚠️</span>
                <h3 class="modal-title">业主方确认</h3>
            </div>

            <!-- 提示信息 -->
            <div class="tip-box">
                <span class="tip-icon">ⓘ</span>
                <p class="tip-text">
                    该项目的业主方不在集团客商库内，请在[集团门户-CRM-客户关系管理]中申请登记同名客商，并在CRM 系统申请成功之后，再来本系统进行进度确认。如需修改业主方，请联系生产经营部。
                </p>
            </div>

            <!-- 业主方显示框 -->
            <div class="owner-display">
                <label class="form-label">业主方：</label>
                <div class="owner-input">
                    <a-icon type="bank" class="input-icon" />
                    <span class="input-text">{{ selectedOwnerDisplay }}</span>
                </div>
            </div>

            <!-- 客户列表区 -->
<!--            <div class="client-section">-->
<!--                <label class="section-label">客户列表</label>-->

<!--                <a-input-search-->
<!--                  placeholder="请输入公司名搜索"-->
<!--                  enter-button-->
<!--                  @search="onSearch"-->
<!--                ></a-input-search>-->

<!--                <Padding />-->

<!--                <a-table-->
<!--                  bordered-->
<!--                  :data-source="list"-->
<!--                  :loading="loading"-->
<!--                  @change="onChange"-->
<!--                  :pagination="{-->
<!--                    total,-->
<!--                    current,-->
<!--                    pageSize,-->
<!--                    showTotal: (total) => `共 ${total} 条记录`,-->
<!--                  }"-->
<!--                  :rowClassName="rowClassName"-->
<!--                  :customRow="customRow"-->
<!--                >-->
<!--                  <a-table-column title="编码" data-index="custCode" />-->
<!--                  <a-table-column title="名称" data-index="custName" />-->
<!--                </a-table>-->
<!--            </div>-->

            <!-- 底部按钮 -->
            <div class="modal-footer">
                <a-button @click="cancel" class="btn-close">关闭</a-button>
<!--                <a-button type="primary" @click="handleSave" class="btn-save">保存</a-button>-->
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
    name: "OwnerConfirmModal",
    props: {
        partyAname: {
            type: String,
            default: "",
        },
        visible: {
            type: Boolean,
            default: undefined,
        },
    },
    data() {
        return {
            innerVisible: false,
            selectedOwner: null,
        };
    },

    computed: {
        ...mapState("companySelector", [
            "loading",
            "current",
            "pageSize",
            "list",
            "total",
        ]),
        modalVisible: {
            get() {
                return this.visible !== undefined ? this.visible : this.innerVisible;
            },
            set(val) {
                if (this.visible !== undefined) {
                    this.$emit("update:visible", val);
                } else {
                    this.innerVisible = val;
                }
            },
        },
        selectedOwnerDisplay() {
            if (this.selectedOwner) {
                return `${this.selectedOwner.custName}-${this.selectedOwner.custCode}`;
            }
            return this.partyAname || "-";
        },
    },

    watch: {
        modalVisible(newValue) {
            if (newValue) {
                this.selectedOwner = null;
                if (this.list.length === 0) {
                    this.getList();
                }
            }
        },
    },

    methods: {
        ...mapMutations("companySelector", [
            "setCurrent",
            "setPageSize",
            "setSearchValue",
        ]),
        ...mapActions("companySelector", ["getList"]),

        onSearch(value) {
            this.setSearchValue(value.trim());
            this.setCurrent(1);
            this.getList();
        },

        onChange(pagination) {
            this.setCurrent(pagination.current);
            this.setPageSize(pagination.pageSize);
            this.getList();
        },

        rowClassName(record) {
            return this.selectedOwner?.custCode === record.custCode ? 'selected-row' : 'clickable';
        },

        customRow(record) {
            return {
                on: {
                    click: () => {
                        this.selectedOwner = record;
                    },
                },
            };
        },

        handleSave() {
            if (!this.selectedOwner) {
                this.$message.warning("请先选择客户");
                return;
            }
            this.$emit("change", this.selectedOwner);
            this.modalVisible = false;
        },

        cancel() {
            this.modalVisible = false;
        },
    },
};
</script>

<style lang="less" scoped>
.owner-confirm-modal {
  /deep/ .ant-modal-content {
    border-radius: 12px;
    padding: 24px;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 16px;

  .warning-icon {
    font-size: 22px;
    color: #faad14;
    margin-right: 8px;
  }

  .modal-title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
  }

}

.tip-box {
  background: #fff7cc;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  margin-bottom: 20px;

  .tip-icon {
    color: #d48806;
    margin-right: 8px;
    font-size: 16px;
    line-height: 1.5;
    flex-shrink: 0;
  }

  .tip-text {
    margin: 0;
    color: #8b4513;
    font-size: 14px;
    line-height: 1.6;
  }
}

.form-label {
  display: block;
  font-size: 15px;
  color: #333;
  margin-bottom: 8px;
}

.owner-display {
  margin-bottom: 24px;

  .owner-input {
    display: flex;
    align-items: center;
    background: #eaf4ff;
    border: 2px solid #4096ff;
    border-radius: 8px;
    padding: 14px 16px;

    .input-icon {
      font-size: 18px;
      color: #4096ff;
      margin-right: 10px;
    }

    .input-text {
      font-size: 16px;
      color: #0050b3;
    }
  }
}

.client-section {
  .section-label {
    display: block;
    font-size: 15px;
    color: #333;
    margin-bottom: 12px;
  }
}

/deep/ .selected-row {
  background-color: #e6f7ff;
}

/deep/ .clickable {
  cursor: pointer;
}
.modal-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 28px;

  .btn-close {
    min-width: 110px;
    height: 48px;
    font-size: 16px;
    background: #f0f4f8;
    border: none;
    color: #333;
    border-radius: 8px;
  }

  .btn-save {
    min-width: 110px;
    height: 48px;
    font-size: 16px;
    background: #0f3667;
    border-color: #0f3667;
    border-radius: 8px;
  }
}
</style>